import {Component, computed, effect, inject, input, output, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {
  HrToolProviderCandidateResponse,
  ProjectDecisionControllerService,
  ProviderTenantMappingResponse,
} from '@frontend/shared';
import {ModelFieldSelectComponent} from '../../../../../../../../../shared/components/inputs/model-field/model-field-select/model-field-select.component';

@Component({
  selector: 'app-winner-selection',
  imports: [TranslocoPipe, Button, ModelFieldSelectComponent],
  templateUrl: './winner-selection.component.html',
})
export class WinnerSelectionComponent {
  private readonly projectDecisionController = inject(ProjectDecisionControllerService);

  projectId = input.required<number>();
  options = input.required<ProviderTenantMappingResponse[]>();
  isReadOnly = input.required<boolean>();
  preselectedId = input<string | null>(null);

  winnerTagged = output<HrToolProviderCandidateResponse>();

  protected readonly selectedHrToolDirectusUuid = signal<string | null>(null);
  protected readonly isTaggingWinner = signal(false);

  protected readonly isDropdownReadOnly = computed(
    () => this.isReadOnly() || this.isTaggingWinner(),
  );
  protected readonly canTagWinner = computed(
    () => !this.isReadOnly() && this.selectedHrToolDirectusUuid() !== null,
  );

  constructor() {
    effect(() => {
      const preselectedId = this.preselectedId();
      if (preselectedId) {
        this.selectedHrToolDirectusUuid.set(preselectedId);
      }
    });
  }

  protected tagWinner() {
    const hrToolDirectusUuid = this.selectedHrToolDirectusUuid()!;
    this.isTaggingWinner.set(true);
    this.projectDecisionController
      .tagWinner({
        projectId: this.projectId(),
        hrToolProviderWinnerRequest: {hrToolDirectusId: hrToolDirectusUuid},
      })
      .subscribe({
        next: (response) => {
          this.winnerTagged.emit(response);
          this.isTaggingWinner.set(false);
        },
        error: () => this.isTaggingWinner.set(false),
      });
  }
}
